import React from 'react';
import './metodosPago.css';

const MetodosPago = () => {
  const metodosPago = [
    {
      id: 1,
      titulo: "Transferencia Bancaria",
      imagen: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
      descripcion: "Realiza pagos de forma segura y directa a través de transferencia bancaria. Proceso rápido y confiable con confirmación inmediata.",
      caracteristicas: [
        "Transferencia inmediata",
        "Sin comisiones adicionales",
        "Confirmación automática"
      ]
    },
    {
      id: 2,
      titulo: "Tarjetas de Crédito/Débito",
      imagen: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
      descripcion: "Aceptamos todas las tarjetas principales. Proceso de pago seguro y encriptado para tu tranquilidad.",
      caracteristicas: [
        "Visa, Mastercard, American Express",
        "Pago seguro encriptado",
        "Proceso instantáneo"
      ]
    },
    {
      id: 3,
      titulo: "Pago en Efectivo",
      imagen: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
      descripcion: "Para quienes prefieren el pago en efectivo, ofrecemos la opción de pago en nuestras oficinas o puntos autorizados.",
      caracteristicas: [
        "Pago en oficinas",
        "Puntos autorizados",
        "Recibo inmediato"
      ]
    }
  ];

  return (
    <div className="metodos-pago-container">
      <div className="metodos-pago-header">
        <h2>Métodos de Pago</h2>
        <p>Ofrecemos múltiples opciones de pago para tu comodidad</p>
      </div>

      <div className="metodos-pago-list">
        {metodosPago.map((metodo) => (
          <div key={metodo.id} className="metodo-pago-item">
            <div className="metodo-pago-imagen">
              <img src={metodo.imagen} alt={metodo.titulo} />
            </div>
            <div className="metodo-pago-contenido">
              <h3>{metodo.titulo}</h3>
              <p className="metodo-pago-descripcion">{metodo.descripcion}</p>
              <ul className="metodo-pago-caracteristicas">
                {metodo.caracteristicas.map((caracteristica, index) => (
                  <li key={index}>
                    <span className="check-icon">✓</span>
                    {caracteristica}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetodosPago; 